const bankBranchMask = [
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];
export default bankBranchMask;
